import { TvCanvas } from '@sloyd/3d';
import * as icons from '@sloyd/icons';
import { Button, GeneratorDetails } from '@sloyd/ui';
import { Wrapper } from './ContentGeneratorDetails.style';

export type ContentGeneratorDetailsProps = {
  generator: IGenerator;
  palettes: IPalettes;
  unityVersion: UnityVersion;
  callbacks: {
    onOpenInPlayground: (id: string) => void;
    onRandomize: () => void;
  };
};

export function ContentGeneratorDetails(props: ContentGeneratorDetailsProps) {
  const { generator, palettes, unityVersion, callbacks } = props;

  return (
    <Wrapper
      className='ContentGeneratorDetails-wrapper'
      data-testid='ContentGeneratorDetails-wrapper'
    >
      <GeneratorDetails generator={generator} onOpenInPlayground={callbacks.onOpenInPlayground}>
        <TvCanvas generator={generator} palettes={palettes} unityVersion={unityVersion}>
          <Button
            variant='outline'
            leftSection={<icons.IconDice6 />}
            data-track
            className='Randomize-btn'
            size='xs'
            onClick={callbacks.onRandomize}
          >
            Randomize
          </Button>
        </TvCanvas>
      </GeneratorDetails>
    </Wrapper>
  );
}

export default ContentGeneratorDetails;
